module.exports = __webpack_public_path__ + "static/img/tjxq.61782c26.png";